<template>
  <div class="dialogue-modal">
    <h2 class="g-title">
      {{ ModalData.data.title }}
    </h2>

    <div
      v-if="ModalData.data.spinner"
      class="dialogue-modal__spinner"
    />

    <p class="g-title g-title--subtitle">
      {{ ModalData.data.text }}
    </p>

    <ul
      v-if="ModalData.data.options && ModalData.data.options.length"
      class="dialogue-modal__options"
    >
      <li
        v-for="button in ModalData.data.options"
        :key="button.label"
        class="dialogue-modal__options__option"
      >
        <button
          class="g-btn"
          @click="ClickBtn(button)"
        >
          {{ button.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'
export default {
  name: 'Dialoguemodal',
  mixins: [SocketHandler],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  methods: {
    ClickBtn(button) {
      this.$emit('SetPageMessage', {
        target: this.ModalData.data.prefix + button.value,
        choice: button.value,
        data: this.ModalData.data.data
      })

      this.$nextTick(() => {
        this.$emit('CloseModal')
      })
    }
  }
}
</script>

<style lang="scss">
.dialogue-modal {
  width: 100%;
  background: $color-white;
  border-radius: $application-base-border-radius;
  max-width: 500px;
  padding: 10px;
  line-height: 22px;

  > * {
    text-align: center;
    padding: 0;
    margin-top: 10px !important;
  }

  &__spinner {
    text-align: center;
    @include spinner('after', 80px, 5px, $color-grey);
  }

  &__options {
    display: flex;
    justify-content: center;
    &__option {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
